import axios from 'axios'
export default {
    namespaced: true,
    state: {
		user:{
			userId: null,
			name: null,
			email: null,
			usingCode: null,
			codes: [],
			sites: [],
		},
		mediaManager: {
			loaded: false,
			loading: false,
			nextMediaUrl: null,
			nextMediaUrlVideos: null,
			medias: [],
			videos: []
		},
		newImages: [],
		newVideos: []
	},
	getters: {
		getMediaManagerMedias: state => {
			return state.mediaManager.medias;
		},
		getMediaManagerMediasVideos: state => {
			return state.mediaManager.videos;
		},
		getMediaManagerFilterOptions: state => {
			return [...new Set(state.mediaManager.medias.map(img => img.source))]
		},
		getNextMediaUrl: state => {
			return state.mediaManager.nextMediaUrl;
		},
		getNextMediaUrlVideos: state => {
			return state.mediaManager.nextMediaUrlVideos;
		},
		getMediaManagerStatus: state => {
			return state.mediaManager.loaded;
		},
		getMediaManagerLoading: state => {
			return state.mediaManager.loading;
		},
		getNewImages: state => {
			return state.newImages;
		}
    },
	mutations: {
		updateUser(state, payload){
			state.user = {...state, ...payload};
		},
		setNextMediaUrl: (state, nextMediaUrl) => {
			state.mediaManager.nextMediaUrl = nextMediaUrl;
		},
		setNextMediaUrlVideos: (state, nextMediaUrl) => {
			state.mediaManager.nextMediaUrlVideos = nextMediaUrl;
		},
		updateMediaManager(state, payload){
			state.mediaManager.loaded = true;
			state.mediaManager.nextMediaUrl = payload.next;
			state.mediaManager.medias = [ ...state.mediaManager.medias, ...payload.content];
		},
		updateMediaManagerVideos(state, payload){
			state.mediaManager.loaded = true;
			state.mediaManager.nextMediaUrlVideos = payload.next;
			state.mediaManager.videos = [ ...state.mediaManager.videos, ...payload.content];
		},
		filtersMediaManager(state, payload) {
			state.mediaManager.loaded = true;
			state.mediaManager.nextMediaUrl = payload.next;
			state.mediaManager.medias = payload.content;
		},
		filtersMediaManagerVideos(state, payload) {
			state.mediaManager.loaded = true;
			state.mediaManager.nextMediaUrlVideos = payload.next;
			state.mediaManager.videos = payload.content;
		},
		unshiftUploadedImages(state, payload){
			payload.forEach(element => {
				state.mediaManager.medias.unshift(element);
			});
		},
		unshiftUploadedVideos(state, payload){
			payload.forEach(element => {
				state.mediaManager.videos.unshift(element);

				state.newVideos = [];
			});
		},
		updateLoading(state, status) {
			state.mediaManager.loading = status
		}
	},
    actions:{
		GET_USER_MEDIAS( context, [token, siteId] ){
			this.commit("userModule/updateLoading", true)
			axios({
				method: "get",
				url: `${process.env.ROOT_API}api/site/${siteId}/file/list?filetype=image`,
				data: "",
				headers: {
					Authorization: "Bearer " + token
					// 'Content-Type': 'application/x-www-form-urlencoded'
				}
			})
				.then(response => {
					if (response.data.status == 1) {
						// console.log(response.data.content);
						this.commit("userModule/updateMediaManager", response.data);
					} else {
						console.log([]);
					}
					setTimeout(() => {
						this.commit("userModule/updateLoading", false)
					});
				})
				.catch(response => {
					this.commit("userModule/updateLoading", false)
					console.log("Falha buscar imagens");
				});
		},
		UPDATE_MEDIAS(context, [dataMedias]){
			this.commit("userModule/updateMediaManager", dataMedias)
		},
		UPDATE_VIDEOS(context, [dataVideos]){
			this.commit("userModule/updateMediaManagerVideos", dataVideos)
		},
		FILTERS_MEDIAS(context, [token, siteId, search, filter]){
			this.commit("userModule/updateLoading", true);

			var uriSearch = '';
			var uriFilter = '';

			if (typeof search != undefined || search != null) {
				uriSearch = 'search=' + search;
			}

			if (typeof filter != undefined || filter != null) {
				var explode = filter.split('-');
				uriFilter = 'sort=' + explode[0].toLowerCase() + '&order=' + explode[1].toLowerCase();
			}

			axios({
				method: "get",
				url: `${process.env.ROOT_API}api/site/${siteId}/file/list?filetype=image&` + uriSearch + '&' + uriFilter,
				headers: {
					Authorization: "Bearer " + token
					// 'Content-Type': 'application/x-www-form-urlencoded'
				}
			})
				.then(response => {
					if (response.data.status == 1) {
						this.commit("userModule/filtersMediaManager", response.data);
					} else {
						console.log([]);
					}
					setTimeout(() => {
						this.commit("userModule/updateLoading", false)
					});
				})
				.catch(response => {
					this.commit("userModule/updateLoading", false)
					console.log("Falha buscar imagens");
				});
		},
		FILTERS_VIDEOS(context, [token, siteId, search, filter]){
			this.commit("userModule/updateLoading", true);

			var uriSearch = '';
			var uriFilter = '';

			if (typeof search != undefined || search != null) {
				uriSearch = 'search=' + search;
			}

			if (typeof filter != undefined || filter != null) {
				var explode = filter.split('-');
				uriFilter = 'sort=' + explode[0].toLowerCase() + '&order=' + explode[1].toLowerCase();
			}

			axios({
				method: "get",
				url: `${process.env.ROOT_API}api/site/${siteId}/file/list?filetype=video&` + uriSearch + '&' + uriFilter,
				headers: {
					Authorization: "Bearer " + token
					// 'Content-Type': 'application/x-www-form-urlencoded'
				}
			})
				.then(response => {
					if (response.data.status == 1) {
						this.commit("userModule/filtersMediaManagerVideos", response.data);
					} else {
						console.log([]);
					}
					setTimeout(() => {
						this.commit("userModule/updateLoading", false)
					});
				})
				.catch(response => {
					this.commit("userModule/updateLoading", false)
					console.log("Falha buscar videos");
				});
		},
		UNSHIFT_UPLOADED_IMAGES(context, [images]){
			this.commit("userModule/unshiftUploadedImages", images)
		},
		UNSHIFT_UPLOADED_VIDEOS(context, [videos]){
			this.commit("userModule/unshiftUploadedVideos", videos)
		},
		END_MEDIA(context, nextMediaUrl){
			this.commit("userModule/setNextMediaUrl", nextMediaUrl)
		},
		END_VIDEOS(context, nextMediaUrl){
			this.commit("userModule/setNextMediaUrl", nextMediaUrl)
		},
		SET_NEW_IMAGES(context, [newImages]){
			this.commit("userModule/setNewImages", newImages)
		}
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/userModule.js